// extracted by mini-css-extract-plugin
export default {"amount":"style_amount__XFooL","icon":"style_icon__B2JaD"};